import { Icon } from "@deligoo/ui"
import Tippy from "@tippyjs/react"
import { useState } from "react"
import { useFormContext, useWatch } from "react-hook-form"

import { OrderStatusBadge } from "@/components/OrderStatusBadge"
import { OrderPointState } from "@/types"
import { ORDER_POINT_ALLOWED_STATES } from "@/utils"

import cls from "../EditOrderPanel.module.scss"

type StateSelectProps = {
  name: "pickup_attributes.state" | "delivery_attributes.state"
  defaultValue: OrderPointState
}

export const StateSelect = ({ name, defaultValue }: StateSelectProps) => {
  const [isOpen, setOpen] = useState(false)

  const { setValue, register } = useFormContext()

  const currentState: OrderPointState = useWatch({ name, defaultValue })

  const orderPointsToSelect = ORDER_POINT_ALLOWED_STATES.filter((state) => state !== currentState)

  function onStateSelect(state: OrderPointState) {
    setValue(name, state)
    setOpen(false)
  }

  return (
    <div className="mt-8">
      <div className="text-muted mb-3">Status</div>

      <div>
        <Tippy
          visible={isOpen}
          onClickOutside={() => setOpen(false)}
          placement="bottom"
          theme="light"
          interactive
          content={
            <div className={cls.badgeList}>
              {orderPointsToSelect.map((state) => (
                <button onClick={() => onStateSelect(state)} key={state} type="button">
                  <OrderStatusBadge state={state} size="small" className={cls.badge} />
                </button>
              ))}
            </div>
          }
        >
          <button onClick={() => setOpen((currentState) => !currentState)} type="button">
            <OrderStatusBadge state={currentState} />
            <Icon name="chevron-tiny-down" color="muted" className="ml-2" />
          </button>
        </Tippy>
      </div>

      <input defaultValue={defaultValue} {...register(name)} type="hidden" />
    </div>
  )
}
